import mi from 'message-interpolation';

export const langList = {
  'da-DK': 'Dansk',
  'de-DE': 'Deutsch',
  'en-AU': 'English (Australia)',
  'en-US': 'English',
  'es-ES': 'Español',
  'fr-CA': 'Français (Canada)',
  'fr-FR': 'Français',
  'id-ID': 'Indonesia',
  'it-IT': 'Italiano',
  'ja-JP': '日本語',
  'ko-KR': '한국어',
  'nb-NO': 'Norsk',
  'nl-NL': 'Nederlands',
  'pt-BR': 'Português Brasileiro',
  'ru-RU': 'Россия',
  'sv-SE': 'Svenska',
  'th-TH': 'ไทย',
  'tr-TR': 'Türkçe',
  'vi-VN': 'Tiếng Việt',
  'zh-HK': '繁體中文 - 香港',
  'zh-TW': '繁體中文 - 台灣',
};

export const getLang = (lang) => {
  if (!lang) return;
  
  const langListKeys = Object.keys(langList);

  if (langListKeys.includes(lang)) {
    return lang;
  }

  const liteLangListKeys = langListKeys.map(lang => lang.split(/[-]/)[0]);
  const ISO_639_1 = lang.split(/[-]/)[0];

  if (liteLangListKeys.includes(ISO_639_1)) {
    if (ISO_639_1 === 'en') return 'en-US';
    if (ISO_639_1 === 'zh') return 'en-US';
    if (ISO_639_1 === 'fr') return 'fr-FR';

    for (let i = 0; i < langListKeys.length; i += 1) {
      const lang = langListKeys[i];

      if (lang.startsWith(ISO_639_1)) {
        return lang;
      }
    }
  }

  return 'en-US';
};

export const injectLanguage = (state, { userLang, lang }) => {
  state.userLang = userLang;
  state.lang = lang;
};

export default {
  install(Vue) {
    Vue.prototype.$f = mi;
  },
};
